import ResetPasswordContainer from './reset_password_container';

const ResetPassword = ResetPasswordContainer;
export default ResetPassword;
